module.exports = __webpack_public_path__ + "img/C3.7c8bd0d7.png";